<template>
    <div class="input-group-flex"
         :class="{'input-group-flex--no-gap': hasAge}">
        <DtDatePick v-model="value"
                    :selectable-year-range="selectableYearRange"
                    class="input-group-flex__input"
                    format="DD/MM/YYYY">
            <template v-slot:default="{ open, inputValue, processUserInput }">
                <input ref="input"
                       type="text"
                       :value="inputValue"
                       class="field-instance-input form-control input-lg dob-input"
                       :data-instance-key="instance.key"
                       :data-field-type="instance.field.type"
                       :name="`fields-${instance.key}`"
                       :required="instance.field.required"
                       placeholder="DD/MM/YYYY"
                       autocomplete="off"
                       @input="processUserInput($event.target.value)"
                       @focus="open()"
                       @click="open()" />
            </template>
        </DtDatePick>
        <div v-if="hasAge"
             ref="age"
             class="input-group-flex__addon">
            {{ l('FIELDS.AGE') }}: {{ age }}
        </div>
    </div>
</template>

<script>
import DtDatePick from '@/vue/components/DatePicker/DtDatePick';
import { calculateAgeFromDob } from '@/functions/age';

export default {
    components: { DtDatePick },

    props: {
        /**
         * @type {FieldInstance}
         */
        instance: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            value: this.instance.value || '',
            age: null,
        };
    },

    computed: {
        hasAge() {
            return this.age !== null;
        },

        selectableYearRange() {
            const currentYear = (new Date()).getFullYear();
            return {
                // The user can type in a year further ago than this. But validation will prevent it
                // being more than 150 years.
                from: currentYear - 100,
                to: currentYear,
            };
        },
    },

    watch: {
        value: {
            handler() {
                this.updateAge();
            },
            immediate: true,
        },
    },

    methods: {
        updateAge() {
            this.instance.error = null;
            this.age = null;

            if (this.value) {
                try {
                    this.age = calculateAgeFromDob(this.value);
                } catch (e) {
                    this.instance.error = e.langKey;
                }
            }
        },
    },
};
</script>
